import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { array, func } from 'prop-types';
import { startUpdateDashboardSettings } from '../../actions/webmaster';
import { STATIC_PATH } from '../../config';

const propTypes = {
  item: array.isRequired,
  startUpdateDashboardSettings: func.isRequired,
  intl: intlShape.isRequired,
};
const defaultProps = {
  item: {},
  startUpdateDashboardSettings() {},
};

const WIDGET_ID = 20;

const IntroCategoryBlock = ({ item, history, config, startUpdateDashboardSettings, intl, theme }) => {
  const getTranslationIndex = () => {
    let index = 4;
    if(STATIC_PATH === '') {
      index = 3;
    }
    // if(theme === 3) {
    //   return index + 1;
    // }
    return index;
  };
  const renderItem = item => {
    const handleClick = e => {
      e.preventDefault();

      const cfg = config.map(item => {
        if (item.id === WIDGET_ID) {
          return {
            ...item,
            enabled: false,
          };
        }

        return item;
      });

      history.push(item.link);

      setTimeout(() => {
        startUpdateDashboardSettings(cfg);
      }, 0);
    };

    const translationIndex = getTranslationIndex();
    const translationPath = item.img.split('/')[translationIndex].replace(/[.].*/gi, '');
    return (
      <a href={item.link} key={translationPath} className="intro-widget-item" onClick={handleClick}>
        <div className="intro-widget-item-inner">
          <div className="intro-widget-item-image">
            <img
              src={item.img}
              alt={intl.formatMessage({
                id: `intro.items.${translationPath}`,
                defaultMessage: item.title,
              })}
            />
          </div>
          <div className="intro-widget-item-title">
            <FormattedMessage
              tag="span"
              id={`intro.items.${translationPath}`}
              defaultMessage={item.title}
            />
          </div>
        </div>
      </a>
    );
  };

  return <div className="intro-widget-item-container">{item.map(item => renderItem(item))}</div>;
};

IntroCategoryBlock.propTypes = propTypes;
IntroCategoryBlock.defaultProps = defaultProps;

const mapStateToProps = state => ({
  config: state.webmaster.dashboardSettings,
  theme: state.webmaster.profile.theme,
});

const mapDispatchToProps = dispatch => ({
  startUpdateDashboardSettings: (settings, type) =>
    dispatch(startUpdateDashboardSettings(settings)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(injectIntl(IntroCategoryBlock)));
